import { render, staticRenderFns } from "./CustomerShowHistoryEntry.vue?vue&type=template&id=6db73536"
import script from "./CustomerShowHistoryEntry.vue?vue&type=script&lang=js"
export * from "./CustomerShowHistoryEntry.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowHistoryEntry.vue?vue&type=style&index=0&id=6db73536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports